import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink-950" data-id="element-57" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-10 sm:flex-row sm:items-center sm:justify-between" data-id="element-58" data-mp="3gfiugihumbe4">
        <p className="font-semibold tracking-[0.2em] text-white" data-id="element-59" data-mp="32p5m4f11ouo9">GROWTH EULER</p>
        <p className="text-sm text-zinc-600" data-id="element-60" data-mp="36ooajks2rnvu">
          Growth Partner para marcas DTC de suplementos y salud
        </p>
        <p className="text-sm text-zinc-600" data-id="element-61" data-mp="3ugboz385h6h8">
          © {new Date().getFullYear()} Growth Euler
        </p>
      </div>
    </footer>;
}